module.exports = new __parcel__URL__("fda3de81-5ac8-4693-a4d7-a88794f085cd.8280f03c.jpg").toString();